module.exports = __webpack_public_path__ + "static/media/matching-education-medial-flexion-up.aa8dde99.png";